import React from 'react';
import Immutable from 'immutable';
import { useTranslation } from 'react-i18next';

import {
  Container,
  FormikWrapper,
} from '@uncinc/uncinc-react-kitchen-sink';

import {
  Node,
  ViewFilters,
  useViewFilterQuery,
} from '@uncinc/react-drupal-core';
import {
  ImmutableEntity,
  Pager as PageType,
} from '@uncinc/react-drupal-core/types';

import { NodeArticle } from '../../../types/uncinc_profile/nodes';
import { ViewFilter, Pager } from '../../../components';
import {
  Filter,
  FilterProps,
} from '../../../components/ViewFilter';

import './style.scss';

interface ProjectsFilteredProps {
  entities: Immutable.List<ImmutableEntity<NodeArticle>>;
  pager: Immutable.List<ImmutableEntity<PageType>>;
  filters: Filter[];
}

const ProjectsFiltered: React.FC<ProjectsFilteredProps> = ({ entities, pager, filters }) => {
  const totalPages = Number(pager.getIn(['total_pages']));
  const { page, setCurrentPage, setFilters } = useViewFilterQuery();
  const currentPage: number = Number(page) + 1;
  const { t } = useTranslation();

  return (
    <FormikWrapper>
      <Container>
        <ViewFilters
          viewId="projects_filtered"
          display="default"
          onResetFilter={() => { }}
          onFilterUpdate={(field: any, value: any) => {
            setFilters({
              ...filters,
              [field]: value,
            });
          }}
          onRender={(data: FilterProps) => (
            <ViewFilter {...data} filters={filters} />
          )}
        />

        {entities.size === 0 && (
          <div>
            <h3>{t('pages.search.result_empty_title')}</h3>
            <p>{t('pages.search.result_empty_body')}</p>
          </div>
        )}

        <div className="row">
          {
            entities.map((entity) => {
              const uuid = entity.getIn(['uuid', 0, 'value']);
              const langcode = entity.getIn(['langcode', 0, 'value']);
              const key = `${uuid}:${langcode}`;

              return (
                <Node
                  key={key}
                  entity={entity}
                  viewMode="teaser"
                  classes="col-sm-6 col-md-4"
                />
              );
            })
          }
        </div>

        <div className="ViewProjectsFiltered__pager">
          <Pager
            totalPages={totalPages}
            setCurrentPage={setCurrentPage}
            currentPage={currentPage}
          />
        </div>
      </Container>
    </FormikWrapper>
  );
};

export default ProjectsFiltered;
